// Maps tag to a readable string based on defined rules.
export default function transformTagToReadableString(tag: string): string {
    return tag.startsWith('S-') ? 'Secure ' + tag.substring(2) : tag;
}
